import { render, staticRenderFns } from "./UserPersonalsForm.vue?vue&type=template&id=db98a73c&scoped=true"
import script from "./UserPersonalsForm.vue?vue&type=script&lang=js"
export * from "./UserPersonalsForm.vue?vue&type=script&lang=js"
import style0 from "./UserPersonalsForm.vue?vue&type=style&index=0&id=db98a73c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db98a73c",
  null
  
)

export default component.exports